// src/pages/NotFound/index.jsx
import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';

const NotFound = () => {
    return (
        <div className="not-found-content">
            <Result
                status="404"
                title="404"
                subTitle="抱歉，您访问的页面不存在。"
                extra={
                    <Link to="/">
                        <Button type="primary">返回首页</Button>
                    </Link>
                }
            />
        </div>
    );
};

export default NotFound;